import React,{useEffect,useState} from "react";
import { MDBDataTable } from "mdbreact";
import { Row, Col, Card, CardBody } from "reactstrap";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import {httpGet} from "../../../../src/common/petitions"
import Models from './model.json'
import "../tables.scss";
import "../Puestos.scss";
import { useNavigate } from 'react-router-dom'
import DataLoader from "../../../components/tableData";
const Puestos = () => {
  const [data, setData] = useState(null);
  const [totals, setTotals] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [puestos, setPuestos] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    // Fetch the JSON data from the server
    const fetchData = async () => {
      setIsLoading(true)
      try {
        const rowsData = await httpGet("/tarifas/desgloce/20232024",navigate);
        // const ccutotals = await httpGet("/tarifas/resumes/20232024",navigate);
        // setPuestos()
        // console.log(rowsData);
        setPuestos(rowsData);
        // console.log(rowsData,Models.zafra_normal);
        const jsonData = { "columns": Models.tarifa, "rows": rowsData };
        setData(jsonData);
        setTotals(rowsData.total);
        // console.log(jsonData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
      setIsLoading(false)
    }

    fetchData();
  }, []); 
  const toggleActiveButton = (event, reporte) => {
    event.preventDefault();
    removeOutlineClasses();
    event.target.classList.add(`selected`);
    const jsonData = { "columns": Models[reporte], "rows": puestos };
    // console.log(jsonData);
        setData(jsonData);
  };
  const removeOutlineClasses = () => {
    const buttons = document.querySelectorAll('.selected');
    buttons.forEach(button => {
      button.classList.remove("selected");
    });
  };
  document.title = "Tarifa - IPG";
  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs maintitle="Tarifa" title="Reporte general"  />
          <Row>
            <Col className="col-12">
              <Card>
              <CardBody>
                  <h1>Tarifas</h1>
                  <button
                    className={'me-3 btn btn btn-warning'}
                    onClick={(event) => toggleActiveButton(event,"tarifa")}
                  >
                    <i className="bx bx-download me-1"></i>Tarifa
                    </button>
                  <button
                    // color="primary"
                    className={'me-3 btn btn btn-danger'}
                    onClick={(event) => toggleActiveButton(event,"valorizacion")}
                  >
                    <i className="bx bx-download me-1"></i>Valorizacion
                  </button>

                  <button
                    // color="primary"
                    className={'mi-5 btn btn btn-success '}
                    
                  >
                    <i className="bx bx-download me-1"></i>Aprobar tarifa
                  </button>
                  {/* {data && <MDBDataTable responsive striped bordered noBottomColumns data={data} />} */}
                  {<DataLoader isLoading={isLoading} data={data} />}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Puestos;
